/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Listen_At_SpeedInputs */

const en_mobile_benefits_listen_at_speed = /** @type {(inputs: Mobile_Benefits_Listen_At_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen at up to 4x speed`)
};

const es_mobile_benefits_listen_at_speed = /** @type {(inputs: Mobile_Benefits_Listen_At_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha hasta a 4x de velocidad`)
};

/**
* | output |
* | --- |
* | "Listen at up to 4x speed" |
*
* @param {Mobile_Benefits_Listen_At_SpeedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_listen_at_speed = /** @type {((inputs?: Mobile_Benefits_Listen_At_SpeedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Listen_At_SpeedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_listen_at_speed(inputs)
	return en_mobile_benefits_listen_at_speed(inputs)
});